
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cupons/loja/[storeSlug]",
      function () {
        return require("private-next-pages/cupons/loja/[storeSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cupons/loja/[storeSlug]"])
      });
    }
  